interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'center' | 'left';
  tone?: 'light' | 'dark';
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  tone = 'light',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  const titleColor = tone === 'dark' ? 'text-background-50' : 'text-foreground-950';
  const descColor = tone === 'dark' ? 'text-background-100/80' : 'text-foreground-600';

  return (
    <div className={`${isCenter ? 'text-center mx-auto' : 'text-left'} max-w-2xl`}>
      {eyebrow ? (
        <span
          className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] ${
            tone === 'dark' ? 'text-accent-200' : 'text-primary-600'
          }`}
        >
          <span className={`w-6 h-px ${tone === 'dark' ? 'bg-accent-200' : 'bg-primary-500'}`}></span>
          {eyebrow}
        </span>
      ) : null}
      <h2 className={`font-heading mt-3 text-2xl md:text-4xl font-semibold leading-tight ${titleColor}`}>
        {title}
      </h2>
      <span
        className={`block h-[3px] w-16 rounded-full bg-accent-500 ${isCenter ? 'mx-auto' : ''} mt-4`}
      ></span>
      {description ? <p className={`mt-4 text-sm md:text-base leading-relaxed ${descColor}`}>{description}</p> : null}
    </div>
  );
}